import { HttpStatusCodeType } from '~/enums/HttpStatusCodeType';
import { testIsAxiosError } from '~/redux/api/utils';
import { pilot } from '~/services/serviceInstances';
import { Nullable } from '~/types/Nullable';
import { PilotId } from '~/types/PilotId';

type Request = {
  ufFieldId: string;
};

type ServerResponse = {
  id: PilotId;
  uf_field_id: string;
} | null;

export const getDocumentInformationFieldByUfField = async ({
  ufFieldId,
}: Request): Promise<Nullable<PilotId>> => {
  try {
    const response: ServerResponse = await pilot.get(
      `document-information-fields/by-uf-field/${ufFieldId}/`,
    );

    return response?.id ?? null;
  } catch (error) {
    if (
      testIsAxiosError(error) &&
      error.response?.status === HttpStatusCodeType.NotFound
    ) {
      return null;
    }

    throw error;
  }
};
